package site.shadadman.pages.worklog.StrAIberry

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initDec152021StraAIberryFirstSprintPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("worklog/StrAIberry/dec152021StraAIberryFirstSprint.md", FrontMatterElement.EmptyMap))
}

@Page("/worklog/StrAIberry/dec152021-stra-a-iberry-first-sprint")
@Composable
fun Dec152021StraAIberryFirstSprintPage() {
    org.jetbrains.compose.web.dom.H1(attrs = { id("dec-15-2021-straaiberry-first-sprint") }) {
        org.jetbrains.compose.web.dom.Text("dec-15-2021-StraAIberry-First-Sprint")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("This two weeks marked the beginning of an exciting journey at strAIberry, and I couldn’t be more happy. The team’s vision was clear: bring advanced dental health detection to everyday users through a mobile approach. The core idea revolves around a machine learning model capable of identifying dental issues like misalignment, gaps, or crowding. While they already had a working React Native mobile app (MWP), the real challenge was shifting the jaw detection process from the server to the device itself, a move that drastically reduces latency and server load. Here’s how it works:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The user points their phone’s camera at their upper, lower, or front jaw.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("A TFLite model, originally trained in PyTorch and converted for mobile inference, runs locally on the device.")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("It detects the jaw region, crops it precisely, and assigns a label: ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("upper")
            }
            org.jetbrains.compose.web.dom.Text(", ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("lower")
            }
            org.jetbrains.compose.web.dom.Text(", or ")
            org.jetbrains.compose.web.dom.Em {
                org.jetbrains.compose.web.dom.Text("front")
            }
            org.jetbrains.compose.web.dom.Text(".")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("The cropped image is then sent securely to the server for further analysis. This local processing not only improves performance but also enhances privacy, no raw images leave the device unless explicitly needed.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("The onboarding layouts was ready to start. But before strating we needed to define the user stories. For now we had this main stories:")
        com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
        org.jetbrains.compose.web.dom.Text(" Checkup, Containing two section:")
    }
    org.jetbrains.compose.web.dom.Ul {
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Whitening: ")
            com.varabyte.kobweb.compose.dom.GenericTag<org.w3c.dom.Element>("br", attrs = {})
            org.jetbrains.compose.web.dom.Text(" Input: front jaw picture , Output: A whitening score, showcasing the avg whiteness of their smile")
        }
        org.jetbrains.compose.web.dom.Li {
            org.jetbrains.compose.web.dom.Text("Regular Checkup: User could select what teeth they need to focus most. Input: pictures of the jaw , output: result of the detected issues.")
        }
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Profile: including user info & checkup histories Home: Including a profiler about overall users teeth situation")
    }
}
